import { gqlClient } from '@/api/graphql-client';
import materialKeys from '@/api/queries/materials/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const GetAccountPreferredProductsQuery = graphql(`
  query GetAccountPreferredProducts {
    accountPreferredProducts {
      material {
        id
        name
        preferredSupplierId
        suppliedBy {
          id
          supplier {
            id
            name
          }
          price {
            unitPriceExcTax {
              value
              currency {
                code
                exponent
              }
            }
          }
        }
        productSpec {
          id
          name
          category
          manufacturer
          modelNumber
          domesticHotWaterLitres
          nominalOutputKw
          archivedAt
        }
      }
      lineItem {
        id
        price {
          unitPrice {
            value
            currency {
              code
              exponent
            }
          }
        }
      }
    }
  }
`);

const useGetAccountPreferredProducts = () => {
  const { data, ...rest } = useQuery({
    queryKey: materialKeys.accountPreferredProducts(),
    queryFn: () => {
      return gqlClient.request(GetAccountPreferredProductsQuery);
    },
    meta: { errorMessage: 'Failed to load preferred products' },
  });

  return {
    accountPreferredProducts: data?.accountPreferredProducts,
    ...rest,
  };
};

export default useGetAccountPreferredProducts;
